module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/trending-up-arrow-148269ba90c493101b905d3e3982d436.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/trending-up-arrow.svg
// module id = QiYY
// module chunks = 24